/* Equip Your Door — gated wizard
   Step 0 picks an expertise level. That selection unhides one of three path
   containers (beginner / average / expert) and drives a per-path step
   navigator. No framework, single root, no globals. */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var root = document.querySelector('[data-eyd-root]');
    if (!root) return;

    var form     = root.querySelector('[data-eyd-form]');
    var progress = root.querySelector('[data-eyd-progress]');
    var stepsEl  = root.querySelector('[data-eyd-steps]');
    var hidden   = root.querySelector('[data-eyd-expertise]');

    var pathLabels = {
      beginner: ['Application', 'Photos', 'Contact'],
      average:  ['Application', 'Door details', 'Configuration', 'Contact'],
      expert:   ['Spec sheet']
    };

    var state = {
      path: null,
      step: 0,
    };

    /* ---------- gate selection ---------- */
    root.querySelectorAll('[data-eyd-gate]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var path = btn.getAttribute('data-eyd-gate');
        startPath(path);
      });
    });

    function startPath(path) {
      state.path = path;
      state.step = 1;
      hidden.value = path;
      // hide gate, show selected path container, hide the others
      hidePanel('gate');
      ['beginner', 'average', 'expert'].forEach(function (p) {
        var c = root.querySelector('[data-eyd-path="' + p + '"]');
        if (c) c.hidden = (p !== path);
      });
      // build progress indicator
      buildProgress(path);
      // show first step in this path
      showPathStep(1);
    }

    /* ---------- restart (gear back to gate) ---------- */
    root.querySelectorAll('[data-eyd-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!confirm('Change knowledge level? Your current answers will be cleared.')) return;
        // reset form
        form.reset();
        // clear photo previews + state
        photoState.length = 0;
        if (previews) previews.innerHTML = '';
        // hide all path containers + step panels
        ['beginner', 'average', 'expert'].forEach(function (p) {
          var c = root.querySelector('[data-eyd-path="' + p + '"]');
          if (c) c.hidden = true;
        });
        root.querySelectorAll('.eyd-step-panel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        // show gate, hide progress
        var gate = root.querySelector('[data-step-panel="gate"]');
        if (gate) gate.classList.add('is-active');
        if (progress) progress.hidden = true;
        state.path = null;
        state.step = 0;
        hidden.value = '';
        try { gate.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      });
    });

    /* ---------- progress bar ---------- */
    function buildProgress(path) {
      var labels = pathLabels[path] || [];
      stepsEl.innerHTML = '';
      labels.forEach(function (label, i) {
        var li = document.createElement('li');
        li.className = 'eyd-step';
        li.setAttribute('data-step-indicator', String(i + 1));
        li.innerHTML = '<span class="eyd-step__num">' + (i + 1) + '</span><span class="eyd-step__label">' + label + '</span>';
        stepsEl.appendChild(li);
      });
      progress.hidden = labels.length <= 1;
      progress.setAttribute('aria-valuemin', '1');
      progress.setAttribute('aria-valuemax', String(labels.length));
    }

    function updateIndicators(step) {
      stepsEl.querySelectorAll('.eyd-step').forEach(function (i) {
        var n = parseInt(i.getAttribute('data-step-indicator'), 10);
        i.classList.toggle('is-active', n === step);
        i.classList.toggle('is-done', n < step);
      });
      progress.setAttribute('aria-valuenow', String(step));
    }

    /* ---------- per-path step navigation ---------- */
    function showPathStep(step) {
      // hide all panels in current path, show the one with matching path-step
      var container = root.querySelector('[data-eyd-path="' + state.path + '"]');
      if (!container) return;
      container.querySelectorAll('[data-step-panel]').forEach(function (p) {
        var ps = parseInt(p.getAttribute('data-path-step') || '0', 10);
        p.classList.toggle('is-active', ps === step);
      });
      state.step = step;
      updateIndicators(step);
      try { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    function hidePanel(panel) {
      var p = root.querySelector('[data-step-panel="' + panel + '"]');
      if (p) p.classList.remove('is-active');
    }

    root.querySelectorAll('[data-eyd-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!validateCurrentStep()) return;
        showPathStep(state.step + 1);
      });
    });
    root.querySelectorAll('[data-eyd-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPathStep(Math.max(1, state.step - 1));
      });
    });

    function validateCurrentStep() {
      // Bug fix: if state.path is unset (user never picked a gate option), the
      // form is in an invalid state. Bail out as INVALID, not valid. Previous
      // behavior silently let half-empty submissions through.
      if (!state.path) {
        flashError(root.querySelector('.eyd-step-panel.is-active'),
          'Please pick your knowledge level (Beginner / Average / Expert) at the top of the form before continuing.');
        return false;
      }
      var container = root.querySelector('[data-eyd-path="' + state.path + '"]');
      if (!container) return false;
      var panel = container.querySelector('[data-path-step="' + state.step + '"]');
      if (!panel) return false;

      // Step 1 (any path) — application is required
      if (state.step === 1 && (state.path === 'beginner' || state.path === 'average')) {
        var picked = panel.querySelector('input[name="application"]:checked');
        if (!picked) { flashError(panel, 'Pick the application that best matches.'); return false; }
      }

      // Final step — contact required fields
      var lastStepIndex = pathLabels[state.path].length;
      if (state.step === lastStepIndex || state.path === 'expert') {
        var ok = true;
        ['name', 'company', 'email'].forEach(function (n) {
          var el = panel.querySelector('[name="' + n + '"]');
          if (el && !el.value.trim()) { el.style.borderColor = 'var(--eyd-accent)'; ok = false; }
          else if (el) el.style.borderColor = '';
        });
        var emailEl = panel.querySelector('[name="email"]');
        if (emailEl && emailEl.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value)) {
          emailEl.style.borderColor = 'var(--eyd-accent)'; ok = false;
        }
        if (!ok) { flashError(panel, 'Fill in the required fields above.'); return false; }
      }
      return true;
    }

    function flashError(panel, msg) {
      var existing = panel.querySelector('.eyd-flash'); if (existing) existing.remove();
      var div = document.createElement('div');
      div.className = 'eyd-flash';
      div.style.cssText = 'background:var(--eyd-accent-soft);color:var(--eyd-accent);padding:12px 16px;border:1px solid var(--eyd-accent);font-size:14px;margin-bottom:16px;';
      div.textContent = msg;
      var actions = panel.querySelector('.eyd-actions');
      if (actions) actions.before(div);
      setTimeout(function () { div.remove(); }, 3500);
    }

    /* ---------- photo uploader (one per panel; each gets its own state but
       we collect across the active path on submit) ---------- */
    var photoState = [];
    var previews   = null; // last-active previews container, for restart
    root.querySelectorAll('[data-eyd-uploader]').forEach(function (uploader) {
      var input    = uploader.querySelector('[data-eyd-file-input]');
      var trigger  = uploader.querySelector('[data-eyd-file-trigger]');
      var prev     = uploader.querySelector('[data-eyd-previews]');
      previews = prev;
      if (trigger) trigger.addEventListener('click', function () { input.click(); });
      if (input) input.addEventListener('change', function (e) {
        var files = Array.from(e.target.files || []);
        files.forEach(function (f) {
          if (photoState.length >= 10) return;
          if (f.size > 8 * 1024 * 1024) return;
          if (!f.type.startsWith('image/')) return;
          photoState.push(f);
          addPreview(f, prev);
        });
        e.target.value = '';
      });
    });
    function addPreview(file, prev) {
      var url = URL.createObjectURL(file);
      var card = document.createElement('div');
      card.className = 'eyd-preview';
      card.innerHTML = '<img src="' + url + '" alt=""><button type="button" class="eyd-preview__remove" aria-label="Remove">&times;</button>';
      card.querySelector('.eyd-preview__remove').addEventListener('click', function () {
        var idx = photoState.indexOf(file);
        if (idx >= 0) photoState.splice(idx, 1);
        URL.revokeObjectURL(url);
        card.remove();
      });
      prev.appendChild(card);
    }

    /* ---------- shared FormData builder ----------
       Used by the final submit AND the draft checkpoints. Scopes to the
       active path only so we don't pull empty fields from inactive paths. */
    function buildPayloadFormData(extra) {
      var activePath = root.querySelector('[data-eyd-path="' + state.path + '"]');
      var fd = new FormData();
      fd.set('expertise', state.path || '');
      if (activePath) {
        activePath.querySelectorAll('input, select, textarea').forEach(function (el) {
          if (!el.name || el.disabled) return;
          if (el.type === 'checkbox' || el.type === 'radio') {
            if (el.checked) fd.append(el.name, el.value);
          } else if (el.type === 'file') {
            // photos handled below from photoState
          } else if (el.value !== '') {
            fd.append(el.name, el.value);
          }
        });
      }
      photoState.forEach(function (file) { fd.append('photos', file, file.name); });
      if (extra) Object.keys(extra).forEach(function (k) { fd.set(k, extra[k]); });
      return fd;
    }

    /* ---------- localStorage draft (silent auto-save / auto-restore) ----------
       Saves form state on every input change. Restores silently on page load
       with a "Welcome back" banner. Cleared on successful final submit. */
    var DRAFT_KEY = 'ssgdp-eyd-draft-v1';
    var DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
    var saveTimer = null;

    function saveDraftLocal() {
      try {
        var draft = { path: state.path, step: state.step, fields: {}, ts: Date.now() };
        root.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (el) {
          if (el.disabled || el.type === 'file') return;
          if (el.type === 'radio' || el.type === 'checkbox') {
            if (el.checked) draft.fields[el.name] = el.value;
          } else if (el.value) {
            draft.fields[el.name] = el.value;
          }
        });
        localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
      } catch (e) { /* private mode / quota / etc — silent */ }
    }
    function clearDraftLocal() {
      try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
    }
    function loadDraftLocal() {
      try {
        var raw = localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || !d.path || (Date.now() - (d.ts || 0)) > DRAFT_MAX_AGE_MS) {
          clearDraftLocal();
          return null;
        }
        return d;
      } catch (e) { return null; }
    }

    // Save on every change
    form && form.addEventListener('input', function () {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveDraftLocal, 250);
    });
    form && form.addEventListener('change', saveDraftLocal);

    // Restore prompt
    (function maybeShowRestoreBanner() {
      var d = loadDraftLocal();
      if (!d) return;
      var banner = document.createElement('div');
      banner.className = 'eyd-restore-banner';
      banner.style.cssText = 'background:#fff8e1;border:1px solid #f4d680;border-left:4px solid #d18a00;padding:14px 18px;margin:0 0 18px;display:flex;flex-wrap:wrap;align-items:center;gap:12px;font-size:14px;';
      banner.innerHTML = '<strong style="flex:1 1 auto;">Welcome back.</strong>'
        + '<span style="flex:1 1 100%;color:#5b6470;">You started this form earlier. Want to pick up where you left off?</span>'
        + '<button type="button" class="eyd-btn eyd-btn--primary" data-eyd-resume>Resume</button>'
        + '<button type="button" class="eyd-btn eyd-btn--ghost" data-eyd-discard>Start over</button>';
      form.parentNode.insertBefore(banner, form);
      banner.querySelector('[data-eyd-resume]').addEventListener('click', function () {
        applyDraft(d);
        banner.remove();
      });
      banner.querySelector('[data-eyd-discard]').addEventListener('click', function () {
        clearDraftLocal();
        banner.remove();
      });
    })();

    function applyDraft(d) {
      // Re-populate all named fields
      Object.keys(d.fields).forEach(function (name) {
        root.querySelectorAll('[name="' + name + '"]').forEach(function (el) {
          if (el.type === 'radio' || el.type === 'checkbox') {
            el.checked = (el.value === d.fields[name]);
          } else {
            el.value = d.fields[name];
          }
        });
      });
      // Restore active path + step
      if (d.path) startPath(d.path);
      if (d.step && d.step > 1) showPathStep(d.step);
    }

    /* ---------- server checkpoint (mid-flow draft to Worker) ----------
       Fires after every "Continue" once an email is on file. Best-effort:
       failures are silently swallowed so the user's flow is never blocked. */
    function checkpointDraft() {
      var workerUrl = form && form.getAttribute('data-eyd-worker-url') || '';
      if (!workerUrl) return;
      var emailEl = root.querySelector('[data-eyd-path="' + state.path + '"] input[name="email"]');
      var email = emailEl && emailEl.value && emailEl.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return; // no usable email yet
      var fd = buildPayloadFormData({
        form_type: 'draft-eyd',
        current_step: String(state.step || ''),
      });
      try {
        fetch(workerUrl, { method: 'POST', body: fd, keepalive: true }).catch(function () {});
      } catch (e) { /* swallow */ }
    }

    // Hook into the existing next-button click to also fire a checkpoint
    root.querySelectorAll('[data-eyd-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // checkpoint fires AFTER the step advance, but only if validation passed
        setTimeout(checkpointDraft, 50);
      });
    });

    /* ---------- submit (real fetch to the Cloudflare Worker) ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Hard guard: never submit without a path selected
        if (!state.path) {
          flashError(root.querySelector('.eyd-step-panel.is-active'),
            'Please pick your knowledge level (Beginner / Average / Expert) at the top of the form before submitting.');
          return;
        }
        if (!validateCurrentStep()) return;

        var workerUrl = form.getAttribute('data-eyd-worker-url') || '';
        if (!workerUrl) {
          flashError(root.querySelector('.eyd-step-panel.is-active'),
            'The form is not configured to submit yet. Please call us directly.');
          return;
        }

        // Build the payload now so we can show a preflight summary
        var fd = buildPayloadFormData({ form_type: 'equip-your-door' });

        // Preflight: if user hasn't confirmed yet, show summary screen first
        if (!state.preflightConfirmed) {
          showPreflightSummary(fd, function () {
            state.preflightConfirmed = true;
            // re-fire submit (will skip preflight this time and reach the fetch)
            form.dispatchEvent(new Event('submit', { cancelable: true }));
          }, function () {
            // user clicked Edit — close summary, return to form
            state.preflightConfirmed = false;
          });
          return;
        }
        // From here on, user has confirmed the summary
        state.preflightConfirmed = false; // reset for any future submit attempts

        var submitBtn = e.submitter || form.querySelector('[data-eyd-submit]');
        var originalLabel = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
          submitBtn.classList.add('eyd-btn--loading');
          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Sending';
        }

        fetch(workerUrl, { method: 'POST', body: fd })
          .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
          .then(function (r) {
            if (!r.ok || !r.body || !r.body.ok) {
              throw new Error((r.body && r.body.error) || 'Submission failed');
            }

            // Success: clear the local draft + show case ref + success panel
            clearDraftLocal();
            var caseEl = root.querySelector('[data-eyd-case-ref]');
            if (caseEl) caseEl.textContent = r.body.caseRef || generateCaseRef();

            root.querySelectorAll('.eyd-step-panel').forEach(function (p) { p.classList.remove('is-active'); });
            var success = root.querySelector('[data-step-panel="success"]');
            if (success) success.classList.add('is-active');
            if (stepsEl) stepsEl.querySelectorAll('.eyd-step').forEach(function (i) {
              i.classList.add('is-done'); i.classList.remove('is-active');
            });
            try { success.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
          })
          .catch(function (err) {
            console.error('[EYD] submit failed:', err);
            // restore button so the user can retry
            if (submitBtn) {
              submitBtn.classList.remove('eyd-btn--loading');
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalLabel;
            }
            var panel = root.querySelector('.eyd-step-panel.is-active');
            if (panel) flashError(panel,
              'We couldn\'t send your request. Please try again, or call us directly if the issue continues.');
          });
      });
    }

    function generateCaseRef() {
      var d = new Date();
      var ymd = d.getFullYear().toString().slice(-2) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
      var rand = Math.random().toString(36).slice(-4).toUpperCase();
      return 'EYD-' + ymd + '-' + rand;
    }

    /* ---------- preflight summary screen ----------
       Last-chance confirmation before the final fetch. Shows everything the
       form is about to send. Catches accidental empty fields, gives the user
       an Edit button to return to the form, and a Confirm button to send. */
    var FIELD_LABELS = {
      expertise: 'Knowledge level',
      application: 'Application',
      door_height_ft: 'Door height (ft)',
      door_width_ft: 'Door width (ft)',
      lift_config: 'Lift configuration',
      jamb_material: 'Jamb material',
      headroom_in: 'Headroom (in)',
      components: 'Components flagged',
      track_size: 'Track size',
      track_material: 'Track material',
      mounting: 'Track mounting',
      current_issue: 'Current door issue',
      extra_notes: 'Additional notes',
      name: 'Name',
      company: 'Company',
      email: 'Email',
      phone: 'Phone',
    };
    var REQUIRED_FOR_SUBMIT = ['expertise', 'application', 'name', 'company', 'email'];

    function showPreflightSummary(fd, onConfirm, onEdit) {
      // Build a summary panel and inject it where the form is
      var existing = root.querySelector('[data-eyd-preflight]');
      if (existing) existing.remove();

      var entries = {};
      fd.forEach(function (value, key) {
        if (key === 'photos') return;
        if (entries[key]) {
          entries[key] = [].concat(entries[key], value);
        } else {
          entries[key] = value;
        }
      });
      var photoCount = fd.getAll('photos').length;

      var missing = REQUIRED_FOR_SUBMIT.filter(function (k) {
        return !entries[k] || (typeof entries[k] === 'string' && !entries[k].trim());
      });

      var rows = '';
      Object.keys(FIELD_LABELS).forEach(function (k) {
        if (k in entries) {
          var v = Array.isArray(entries[k]) ? entries[k].join(', ') : entries[k];
          rows += '<div class="eyd-pf-row"><span class="eyd-pf-label">'
            + FIELD_LABELS[k] + '</span><span class="eyd-pf-value">'
            + String(v).replace(/[<>&]/g, function (c) { return ({ '<':'&lt;','>':'&gt;','&':'&amp;' })[c]; })
            + '</span></div>';
        }
      });
      // Hardware grid entries
      Object.keys(entries).filter(function (k) { return k.indexOf('hw_') === 0; }).forEach(function (k) {
        var label = k.replace('hw_', '').replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        rows += '<div class="eyd-pf-row"><span class="eyd-pf-label">' + label
          + '</span><span class="eyd-pf-value">' + entries[k] + '</span></div>';
      });
      if (photoCount) {
        rows += '<div class="eyd-pf-row"><span class="eyd-pf-label">Photos</span><span class="eyd-pf-value">'
          + photoCount + ' attached</span></div>';
      }

      var warningHtml = '';
      if (missing.length) {
        warningHtml = '<div class="eyd-pf-warning"><strong>Missing required:</strong> '
          + missing.map(function (k) { return FIELD_LABELS[k] || k; }).join(', ')
          + '. Click Edit to fill these in.</div>';
      }

      var panel = document.createElement('div');
      panel.className = 'eyd-step-panel is-active eyd-preflight';
      panel.setAttribute('data-eyd-preflight', '1');
      panel.innerHTML =
        '<div class="eyd-panel__head">'
        +   '<span class="eyd-step-tag">Confirm and submit</span>'
        +   '<h2>Ready to send?</h2>'
        +   '<p>This is what we&apos;ll send to our engineering team. Review and confirm.</p>'
        + '</div>'
        + warningHtml
        + '<div class="eyd-pf-list">' + rows + '</div>'
        + '<div class="eyd-actions">'
        +   '<button type="button" class="eyd-btn eyd-btn--ghost" data-eyd-pf-edit>&larr; Edit my answers</button>'
        +   '<button type="button" class="eyd-btn eyd-btn--primary eyd-btn--xl" data-eyd-pf-confirm'
        +     (missing.length ? ' disabled style="opacity:0.5;cursor:not-allowed"' : '') + '>'
        +     'Looks right, submit &rarr;</button>'
        + '</div>';

      // Hide all existing panels, show preflight
      root.querySelectorAll('.eyd-step-panel').forEach(function (p) { p.classList.remove('is-active'); });
      form.appendChild(panel);
      try { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}

      panel.querySelector('[data-eyd-pf-edit]').addEventListener('click', function () {
        panel.remove();
        // Re-show the last active path step
        var container = root.querySelector('[data-eyd-path="' + state.path + '"]');
        if (container) {
          var last = container.querySelector('[data-path-step="' + state.step + '"]');
          if (last) last.classList.add('is-active');
        }
        if (typeof onEdit === 'function') onEdit();
      });
      if (!missing.length) {
        panel.querySelector('[data-eyd-pf-confirm]').addEventListener('click', function () {
          panel.remove();
          if (typeof onConfirm === 'function') onConfirm();
        });
      }
    }
  }
})();

